import classes from "../SeedLister.module.css"
import Input from "../../../components/UI/Input/Input"
import Select from "react-select"
import { default_multi_style, get_murch_filter_labels } from "../../../Utils"
import { useTranslation } from "react-i18next"

const Control = props => {
    const { t } = useTranslation()
    const murch_types = get_murch_filter_labels()
    const ms = default_multi_style()

    return (
        <div className={classes.Wrapper}>
            {/*<Input
                title={t("misc:Checker.CurrentSeed") + " 1"}
                changed={elem => props.seedValidator(elem, 0)}
                val={props.currentSeed[0]}
            />
            <Input
                title={t("misc:Checker.CurrentSeed") + " 2"}
                changed={elem => props.seedValidator(elem, 1)}
                val={props.currentSeed[1]}
            />
            <Input
                title={t("misc:Checker.CurrentSeed") + " 3"}
                changed={elem => props.seedValidator(elem, 2)}
                val={props.currentSeed[2]}
            />
            <Input
                title={t("misc:Checker.CurrentSeed") + " 4"}
                changed={elem => props.seedValidator(elem, 3)}
                val={props.currentSeed[3]}
    />*/}
            <Input
                type="number"
                title={t("misc:Checker.StartSlot")}
                val={props.currentStartFrame}
                changed={props.startValidator}
            />
            <Input
                type="number"
                title={t("misc:Checker.NumberOfSlots")}
                val={props.currentNumberOfFrames}
                changed={props.numberValidator}
            />

            <div className={classes.InputWrapper}>
                <span className={classes.Title}>{t("misc:SeedListing.ShowResultTypes")}</span>
                <div className={classes.DrinkSlots}>
                    <Select
                        defaultValue={murch_types}
                        isMulti
                        name="murch_types"
                        options={murch_types}
                        styles={ms}
                        onChange={props.handleResultTypes}
                        value={props.selectedResultTypes}
                    />
                </div>
            </div>

            <div>
                <button className={classes.Button} onClick={props.calculateResults}>
                    {t("misc:Checker.ButtonDisplayResults")}
                </button>
                <button className={classes.ButtonError} onClick={props.resetSeed}>
                    {t("misc:SeedListing.DeleteSeed")}
                </button>
            </div>
        </div>
    )
}

export default Control
